import Styled from "styled-components";
import { respondTo } from "../../../respondTo";




export const MissionContainer = Styled.div`
    flex-direction: column;
    position: relative;
    justify-content: center;
    width: 100%;
    padding: 2.5rem 0 1.25rem;
    //background-color: var(--primary-container-light);

    ${respondTo.tablet_landscape_s`
        padding: 2.5rem 1.25rem 1.25rem;
    `}
      ${respondTo.desktop`
       padding: 2.5rem;
    `} 

    ${respondTo.desktop_xl`
        padding: 2.5rem 4.375rem;
    `}
    `

export const TextMissionContainer = Styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding:0 1.25rem 2.5rem;
    z-index: 0;

    ${respondTo.tablet_landscape_s`
        text-align: center;
        align-items: center;
        
    `}

    ${respondTo.desktop`
        padding: 0 10rem 3.75rem;
        justify-content: center;
        align-items: center;
        text-align: center;
    `}

    ${respondTo.desktop_xl`
        padding: 0 3rem;
        margin: 0 0 3.75rem;
    `}

    `;


export const CardContainer = Styled.div<{ref : any}>`
    align-items: flex-start;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    overflow-x: auto;
    overflow-y: hidden;
    padding:0.625rem 0.625rem 0;
    z-index: 1;
    scroll-snap-type: x mandatory;
    
    
    ::-webkit-scrollbar {
        display: none;
    }
      ${respondTo.desktop`
      width: 100%;
      justify-content: space-between;
      margin: 0.625rem 0;
      padding: 0;
      
    `} 

    ${respondTo.desktop_HD`
    justify-content: space-evenly;
    `}

    `
